import { Parallax, ParallaxLayer } from "@react-spring/parallax";
import Education from "./components/education";
import Introduction from "./components/intro";
import Script from "./script";
import experienceData from "./components/experience/data";
import projectData from "./components/project/data";
import FloatingCard from "./components/common/FloatingCard";
import ExperienceContent from "./components/experience";
import ProjectContent from "./components/project";
import { useRef } from "react";

function App() {
  const ref = useRef(null);
  const scroll = (to) => {
    if (ref.current) {
      ref.current.scrollTo(to);
    }
  };
  return (
    <div style={{ overflow: "visible" }}>
      <Script />
      <Introduction />
      <Education />
      <Parallax
        ref={ref}
        pages={experienceData.length + projectData.length}
        style={{ scrollSnapType: "y mandatory" }}
      >
        <ParallaxLayer
          sticky={{ start: 0, end: experienceData.length - 1 }}
          className="experience-title-container"
        >
          <div className="experience-title-text-container">
            <h1 className="experience-title">Experience</h1>
            {experienceData.map((experience) => {
              return (
                <h1
                  onClick={() => {
                    scroll(experience.offset);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {experience.offset + 1}
                </h1>
              );
            })}
          </div>
        </ParallaxLayer>
        {experienceData.map((experience) => {
          return (
            <ParallaxLayer
              offset={experience.offset}
              speed={0}
              className="experience-list-container"
            >
              <FloatingCard
                container="experience-container"
                card="experience-card"
                content={<ExperienceContent data={experience} />}
              />
            </ParallaxLayer>
          );
        })}
        <ParallaxLayer
          sticky={{
            start: experienceData.length,
            end: experienceData.length + projectData.length - 1,
          }}
          className="project-title-container"
        >
          <div className="project-title-text-container">
            <h1 className="project-title">Projects</h1>
            {projectData.map((project) => {
              return (
                <h1
                  onClick={() => scroll(project.offset + experienceData.length)}
                  style={{ cursor: "pointer" }}
                >
                  {project.offset + 1}
                </h1>
              );
            })}
          </div>
        </ParallaxLayer>
        {projectData.map((project) => {
          return (
            <ParallaxLayer
              offset={experienceData.length + project.offset}
              speed={0}
              className="project-list-container"
            >
              <FloatingCard
                container="project-container"
                card="project-card"
                content={<ProjectContent data={project} />}
              />
            </ParallaxLayer>
          );
        })}
      </Parallax>
    </div>
  );
}

export default App;
